import { Box, Stack } from '@chakra-ui/react';
import { useQuery } from '@tanstack/react-query';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { StyledScrollWrapper } from '$/components/common/StyledScrollWrapper';
import { ActiveMaterialCard } from '$/components/core/Collection/ActiveMaterialCard';
import { useIsMobile } from '$/hooks/useIsMobile';
import { BackToTopButton } from '$/pages/DashboardPages/components/BackToTopButton';
import { TooltipHeader } from '$/pages/DashboardPages/components/TooltipHeader';
import { FilterSection } from '$/pages/DashboardPages/pages/Inspiration/components/FilterSection';
import { InspirationOverview } from '$/pages/DashboardPages/pages/Inspiration/components/InspirationOverview';
import { materialsQuery } from '$/services/usecases/materials/queries';
import { useMaterialStore } from '$/stores/useMaterialStore';

export const InspirationDashboard = () => {
  const { t } = useTranslation();
  const isMobile = useIsMobile();

  const id = useMaterialStore.useActiveMaterialId();
  const { data } = useQuery(materialsQuery({ ids: id ? [id] : [] }));

  const containerRef = useRef<HTMLDivElement>(null);

  return (
    <Stack w='full' {...(!isMobile && { layerStyle: 'DashboardSection' })}>
      {id && data && (
        <Stack
          layerStyle='DashboardSection'
          m={{ base: '0', mobile: '7' }}
          px='7'
          py='5'
        >
          <ActiveMaterialCard material={data.results[0]} />
        </Stack>
      )}

      <StyledScrollWrapper>
        <Stack
          ref={containerRef}
          gap='5'
          overflowY='auto'
          w='full'
          {...(!isMobile && {
            p: '7',
          })}
        >
          <TooltipHeader
            header={t('dashboard.inspiration.header')}
            info={t('dashboard.inspiration.description')}
          />

          <Box>
            <FilterSection />
          </Box>

          <InspirationOverview />

          <BackToTopButton
            containerRef={containerRef}
            right='65px'
            bottom='65px'
          />
        </Stack>
      </StyledScrollWrapper>
    </Stack>
  );
};
